import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import DataTable from '../../components/Common/DataTable';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import { PlusIcon, PencilIcon, TrashIcon, EyeIcon } from '@heroicons/react/24/outline';

const FileTypes = () => {
  const [fileTypes, setFileTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { get, del } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    fetchFileTypes();
  }, []);

  const fetchFileTypes = async () => {
    setLoading(true);
    const { data } = await get('/api/file-types');
    if (data) setFileTypes(data);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this file type?')) {
      const { error } = await del(`/api/file-types/${id}`);
      if (!error) {
        fetchFileTypes();
      }
    }
  };

  const columns = [
    { header: 'ID', accessor: 'id' },
    { header: 'File Name', accessor: 'fileName' },
    { header: 'File Description', accessor: 'fileDescription' },
    { 
      header: 'Actions', 
      accessor: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => navigate(`/file-types/${row.id}`)}
            className="text-blue-600 hover:text-blue-900"
            title="View"
          >
            <EyeIcon className="h-5 w-5" />
          </button>
          <button
            onClick={() => navigate(`/file-types/edit/${row.id}`)}
            className="text-green-600 hover:text-green-900"
            title="Edit"
          >
            <PencilIcon className="h-5 w-5" />
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="text-red-600 hover:text-red-900"
            title="Delete"
          >
            <TrashIcon className="h-5 w-5" />
          </button>
        </div>
      )
    }
  ];

  if (loading) return <LoadingSpinner />;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">File Types</h1>
        <button
          onClick={() => navigate('/file-types/add')}
          className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 flex items-center space-x-2"
        >
          <PlusIcon className="h-5 w-5" />
          <span>Add File Type</span>
        </button>
      </div>

      <DataTable 
        columns={columns} 
        data={fileTypes}
      />
    </div>
  );
};

export default FileTypes;